import React from "react";
import SignInForm from "../Components/Forms/SignInForm";

const Login = () => {
    return (
        <>
            <SignInForm />
        </>
    )
}

export default Login;